module.exports = __webpack_public_path__ + "static/media/BeaconIcon.23ed44d9.png";